import styled, { css } from 'styled-components';
export const screenReaderOnlyMixin = () => {
    return css `
    position: absolute;
    overflow: hidden;
    width: 1px;
    height: 1px;
    padding: 0;
    border: 0;
    margin: -1px;
    clip: rect(0, 0, 0, 0);
  `;
};
/**
 * Makes sure the text is rendered, but not visible.
 * This way screen readers will read this, but non visually impaired
 * users will not see it.
 */
export const ScreenReaderOnly = styled.span `
  ${screenReaderOnlyMixin}
`;
//# sourceMappingURL=screen-reader-only.js.map